var _path, _rect, _path2, _path3, _path4, _path5, _ellipse, _ellipse2, _ellipse3, _path6, _g, _ellipse4, _ellipse5, _ellipse6, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMaintenanceNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 200,
    viewBox: "0 0 258 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M153.019 197.972C153.019 185.197 153.019 177.752 153.019 164.977",
    stroke: "#5CDA95",
    strokeWidth: 1.0579
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.69632,
    y: 1.19632,
    width: 254.607,
    height: 197.607,
    rx: 9.38271,
    stroke: "#5CDA95",
    strokeOpacity: 0.2,
    strokeWidth: 2.39264
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M254.981 160.212H204.689C203.177 160.302 200.153 161.342 200.153 164.787C200.153 168.231 200.153 188.254 200.153 197.672",
    stroke: "#5CDA95",
    strokeWidth: 1.0579
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M146.637 89.9874H187.144C192.453 89.9874 192.453 89.9874 192.453 75.5968C192.453 71.3528 192.453 61.2732 192.453 58.0902M255.18 132.361H216.949C214.913 132.007 210.842 130.292 210.842 126.26C210.842 122.228 210.842 117.065 210.842 115.915",
    stroke: "#5CDA95",
    strokeWidth: 1.0579
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.186 20.1582L167.857 19.6287C169.568 19.6287 172.989 20.6877 172.989 24.924C172.989 29.1603 172.989 44.6934 172.989 51.9305C173.075 53.9603 174.375 58.0201 178.892 58.0201C183.408 58.0201 212.424 58.3732 226.367 58.5497C228.249 58.6379 232.013 59.9265 232.013 64.3746C232.013 68.8227 232.013 86.3504 232.013 94.5582C232.013 96.3234 230.986 99.8536 226.88 99.8536C222.774 99.8536 217.642 99.8536 215.589 99.8536C214.134 100.03 211.226 101.23 211.226 104.619C211.226 108.008 211.226 112.916 211.226 114.945C211.312 115.563 210.661 116.799 207.377 116.799C204.092 116.799 188.044 116.799 180.431 116.799C178.892 116.799 175.812 117.752 175.812 121.565C175.812 125.377 175.812 148.571 175.812 159.691C176.154 161.456 175.607 164.987 170.68 164.987C165.752 164.987 143.135 164.987 132.443 164.987",
    stroke: "#5CDA95",
    strokeOpacity: 0.2,
    strokeWidth: 1.0579
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M218.207 2.39978V27.3211C218.207 29.1778 219.322 32.8914 223.782 32.8914C228.242 32.8914 246.779 32.8914 255.098 32.8914",
    stroke: "#5CDA95",
    strokeWidth: 1.0579
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 153.085,
    cy: 164.5,
    rx: 2.91539,
    ry: 2.91271,
    fill: "#5CDA95"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 210.915,
    cy: 115.913,
    rx: 2.91539,
    ry: 2.91271,
    fill: "#5CDA95"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 192.415,
    cy: 57.9127,
    rx: 2.91539,
    ry: 2.91271,
    fill: "#5CDA95"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M151.361 64.1234C149.836 63.8754 148.274 64.0165 146.818 64.5338C145.361 65.0511 144.058 65.928 143.028 67.0835C141.062 69.2955 140.45 72.1752 140.922 75.0608C141.35 77.6633 141.917 80.3045 142.045 82.8115C142.224 86.5875 141.651 90.3614 140.361 93.9129C139.194 97.1265 137.531 99.6186 133.967 100.17C133.703 100.212 132.741 100.242 132.467 100.257C132.194 100.271 131.33 100.215 131.063 100.173C127.499 99.6216 125.821 97.1295 124.657 93.895C123.367 90.3435 122.794 86.5696 122.973 82.7936C123.101 80.2955 123.668 77.6513 124.095 75.0429C124.568 72.1573 123.956 69.2776 121.99 67.0657C120.956 65.9109 119.65 65.0361 118.191 64.5219C116.732 64.0076 115.167 63.8706 113.642 64.1234C109.071 64.8716 106.027 68.9437 106 73.2155C105.988 74.8615 106.433 76.4783 107.286 77.8839C108.709 80.2389 111.043 81.956 113.08 83.7386C114.429 84.931 116.76 88.3145 117.903 91.9812C118.595 94.2021 119.16 96.4528 119.718 98.7243C120.502 101.89 121.58 108.884 122.29 112.059C123.706 118.414 128.042 119.854 132.387 120H132.542C136.886 119.854 141.294 118.411 142.71 112.056C143.417 108.881 144.492 101.884 145.282 98.7213C145.843 96.4617 146.405 94.1991 147.097 91.9782C148.24 88.3115 150.571 84.9161 151.92 83.7356C153.957 81.947 156.288 80.2359 157.714 77.8809C158.567 76.4753 159.012 74.8585 159 73.2126C158.976 68.9318 155.944 64.8567 151.361 64.1234Z",
    fill: "#11A97D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_1088_122288)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.6861 10.5883C3.6861 6.49845 7.00157 3.18298 11.0914 3.18298H132.186V197.347H11.0914C7.00157 197.347 3.6861 194.032 3.6861 189.942V10.5883Z",
    fill: "#11A97D",
    fillOpacity: 0.1
  }))), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.8369,
    cy: 14.8541,
    rx: 4.77893,
    ry: 4.77454,
    fill: "#D83F5A"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 28.6426,
    cy: 14.8541,
    rx: 4.77893,
    ry: 4.77454,
    fill: "#E6AC00"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 42.4485,
    cy: 14.8541,
    rx: 4.77893,
    ry: 4.77454,
    fill: "#4AB44A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_1088_122288",
    x: -4.3139,
    y: -4.81702,
    width: 144.5,
    height: 210.164,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImage",
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_1088_122288"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_1088_122288",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaintenanceNew);
export default __webpack_public_path__ + "static/media/maintenance-new.939c1df12653a4d626ab5fb361dc916e.svg";
export { ForwardRef as ReactComponent };